<template>
  <div class="container operator-title-index-container">
    <div class="card">
      <div class="card-header">
        <div class="row">
          <div class="card-header-label col-2">
            <span class="mdi mdi-account-tie custom-icon"></span>
            <span>Puestos de trabajo</span>
          </div>
          <div class="card-header-search-bar col-5">
            <b-form-input
              v-model="filter" 
              id="filter-input"
              placeholder="Escriba aquí el texto a buscar">
            </b-form-input>
          </div>
          <div class="col-3 card-header-pagination">
            <b-pagination 
              v-model="currentPage" 
              :total-rows="filteredList ? filteredList.length : 0"
              :per-page="perPage" 
              aria-controls="list-table"
              style="margin: 0;"
              align="center"
              >
            </b-pagination>
          </div>
          <div class="card-header-action-buttons col-2" >
            <div>
              <ButtonComponent
                :buttonText="'Nuevo'"
                :buttonColor="colors.GREEN_COLOR_BUTTON"
                :buttonAction="createOperatorTitle"
              />
              <ButtonComponent
                :buttonText="'Refrescar'"
                :buttonColor="colors.BLUE_COLOR_BUTTON"
                :buttonAction="refreshList"
              />
            </div>
          </div>
        </div>
      </div>
      <div v-if="isLoading" style="padding: 5ch 0;">
        <SpeenComponent 
          :isAutomatic="true" 
          :ringWidth="14" 
          :spinnerSize="15" 
          :isverticalAligned="true" 
        />
      </div>
      <div class="card-body" v-else>
        <b-table 
          :items="filteredList" 
          :fields="fields" 
          small striped hover 
          :per-page="perPage"
          :current-page="currentPage" 
          id="list-table">
          <template #cell(actions)="data">
            <ButtonComponent
                :buttonText="'Editar'"
                :buttonColor="colors.GREEN_COLOR_BUTTON"
                :buttonAction="() => editOperatorTitle(data.item)"
              />
              <ButtonComponent
                :buttonText="'Borrar'"
                :buttonColor="colors.RED_COLOR_BUTTON"
                :buttonAction="() => confirmDeleteItem(data.item)"
              />
          </template>
        </b-table>
      </div>
    </div>
    <transition name="slide-fade">
      <OperatorTitleModal
        v-if="showOperatortittleModal"
        :isNewOperatorTitle="isNewOperatorTitle"
        :formData="formData"
        @close-modal="closeOperatorTitleModal" 
        @form-submitted="refreshList"
      />
      <ActionConfirmModal
        v-if="showActionConfirmModal"
        :contentMessage="contentMessage"
        :closeModal="closeActionConfirmModal"
        :methodForProp="methodForProp"
      />
    </transition>
  </div>
</template>

<script>
import axios from 'axios';
import SpeenComponent from '../../common/components/SpeenComponent.vue';
import { showCustomErrorSweetAlert, showCustomSuccessSweetAlert } from '../../common/utils';
import OperatorTitleModal from '../components/OperatorTitleModal.vue';
import ButtonComponent from '../../common/components/ButtonComponent.vue';
import Colors from '../../common/colors';
import ActionConfirmModal from "../../common/components/modals/ActionConfirmModal.vue";
import { filterList } from '../../common/utils';

export default {
  name: 'OperatorTitleIndexComponent',
  components: {
    SpeenComponent,
    OperatorTitleModal,
    ButtonComponent,
    ActionConfirmModal
  },
  data() 
  {
    return {
      colors: Colors,
      perPage: 10,
      currentPage: 1,
      filter: '',
      listData: [],
      isLoading: true,
      showOperatortittleModal: false,
      showEditModal: false,
      showActionConfirmModal: false,
      contentMessage: '',
      methodForProp: null,
      currentId: -1,
      isNewOperatorTitle: false,
      formData: {},
      fields: [
        { key: 'descrip', label: 'Descripción', sortable: true, class: 'truncate' },
        { key: 'actions', label: 'Ajustes',     sortable: false}
      ],
    };
  },
  computed: 
  {
    filteredList: function() 
    {
      return filterList(this.listData, this.fields, this.filter);
    }
  },
  methods: 
  {
    getList() 
    {
      this.isLoading = true;
      axios.get('/api/operator-titles')
        .then(response => {
          this.listData = response.data;
        })
        .catch(error => {
          showCustomErrorSweetAlert(error.response.data);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    refreshList() 
    {
      this.getList();
    },
    createOperatorTitle() 
    {
      this.formData = {
        descrip: ''
      };
      this.isNewOperatorTitle = true;
      this.showOperatortittleModal = true;
    },
    closeOperatorTitleModal() 
    {
      this.showOperatortittleModal = false;
    },
    editOperatorTitle(clickedItem) 
    {
      this.formData = {
        id: clickedItem.id,
        descrip: clickedItem.descrip
      };
      this.isNewOperatorTitle = false;
      this.showOperatortittleModal = true;
    },
    confirmDeleteItem(operator) 
    {
      this.contentMessage = `¿Está seguro de que desea eliminar el puesto ${operator.descrip}?`;
      this.methodForProp = () => {
        this.deleteItem(operator);
      };
      this.openActionConfirmModal();
    },
    deleteItem(operator) 
    {
      axios.delete(`/api/operator-titles/${operator.id}`)
        .then(() => {
          showCustomSuccessSweetAlert('Puesto eliminado correctamente');
          this.getList();
        })
        .catch(error => {
          showCustomErrorSweetAlert(error.response.data);
        })
        .finally(() => {
          this.closeActionConfirmModal();
        });
    },
    openActionConfirmModal() 
    {
      this.showActionConfirmModal = true;
    },
    closeActionConfirmModal() 
    {
      this.showActionConfirmModal = false;
    }
  },
  mounted() 
  {
    this.getList();
  }
};
</script>